module.exports = __webpack_public_path__ + "img/logo.8fa485f5.png";